import { jsx as _jsx, jsxs as _jsxs } from "preact/jsx-runtime";
import { Component } from "preact";
import { nl2br } from "../../util/Formatter";
export default class CancelPolicyComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            agreed: false
        };
    }
    render() {
        const cancelPolicy = this.props.planGroup?.cancelPolicy ?? '';
        return (_jsxs("section", Object.assign({ className: `SchedulePayComponent__container cancel-policy ${this.visible() ? '' : 'hide'}`, id: "CancelPolicyComponent" }, { children: [_jsxs("h4", Object.assign({ class: "content__title" }, { children: [_jsx("span", { class: "heading" }, void 0), "\u30AD\u30E3\u30F3\u30BB\u30EB\u30DD\u30EA\u30B7\u30FC"] }), void 0),
                _jsxs("div", Object.assign({ class: "control" }, { children: [_jsx("label", Object.assign({ class: "label" }, { children: "\u30AD\u30E3\u30F3\u30BB\u30EB\u30DD\u30EA\u30B7\u30FC\u3078\u306E\u540C\u610F\u304C\u5FC5\u8981\u3067\u3059" }), void 0),
                        _jsx("div", Object.assign({ class: "mx2 my2 has-background-grey policy-text" }, { children: nl2br(cancelPolicy) }), void 0),
                        _jsx("div", Object.assign({ class: "flex flex__justify-content-center flex__row" }, { children: _jsx("button", Object.assign({ type: "button", className: this.state.agreed ? 'button button__info w50 disabled' : 'button button__info w50', onClick: () => this.toggleAgreed() }, { children: "\u540C\u610F\u3059\u308B" }), void 0) }), void 0)] }), void 0)] }), void 0));
    }
    visible() {
        const cancelPolicy = this.props.planGroup?.cancelPolicy ?? '';
        const preserveStart = this.props.preserveStart;
        return preserveStart !== null && cancelPolicy.length > 0;
    }
    toggleAgreed() {
        this.setState({
            agreed: !this.state.agreed
        });
        this.props.setter(!this.state.agreed);
    }
}
